import { Link } from 'react-router-dom';
import { CONTACT_EMAIL } from './Seo';

const COLUMNS = [
  {
    heading: 'Entdecken',
    links: [
      { to: '/rezepte', label: 'Rezepte' },
      { to: '/wissen', label: 'Wissen' },
      { to: '/felix', label: 'Über Felix' },
      { to: '/magazin', label: 'Magazin' },
      { to: '/kontakt', label: 'Kontakt' },
    ],
  },
  {
    heading: 'Rechtliches',
    links: [
      { to: '/impressum', label: 'Impressum' },
      { to: '/datenschutz', label: 'Datenschutz' },
      { to: '/barrierefreiheit', label: 'Barrierefreiheit' },
      { to: '/sitemap', label: 'Sitemap' },
    ],
  },
];

export function Footer() {
  return (
    <footer className="mt-24 bg-brand-brown text-brand-cream">
      <div className="container-site grid gap-12 py-16 sm:grid-cols-2 lg:grid-cols-4">
        <div className="sm:col-span-2">
          <Link to="/" className="inline-flex items-center gap-3 rounded-sm" aria-label="Felix Genuss – zur Startseite" data-testid="footer-logo-link">
            <img
              src="/assets/brand/logo-256.webp"
              alt="Felix Genuss Logo"
              width="64"
              height="64"
              className="h-16 w-16 rounded-full"
              loading="lazy"
            />
            <span className="font-serif text-2xl font-bold tracking-tight">Felix Genuss</span>
          </Link>
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-brand-cream/85">
            Sternenküche im Napf: hochwertige Rezepte, Zutatenwissen und Inspiration für kleine vierbeinige Feinschmecker – zusammen mit Felix, unserem Bolonka Zwetna.
          </p>
          <p className="mt-4 text-sm">
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              className="rounded-sm font-semibold text-brand-cream underline decoration-brand-gold/60 underline-offset-4 transition-colors duration-200 hover:text-white"
              data-testid="footer-email-link"
            >
              {CONTACT_EMAIL}
            </a>
          </p>
        </div>
        {COLUMNS.map((col) => (
          <nav key={col.heading} aria-label={`Footer: ${col.heading}`}>
            <h2 className="text-sm font-bold uppercase tracking-[0.2em] text-brand-gold">{col.heading}</h2>
            <ul className="mt-5 space-y-3">
              {col.links.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="inline-block rounded-sm text-sm text-brand-cream/85 transition-colors duration-200 hover:text-white"
                    data-testid={`footer-${link.label.toLowerCase()}`}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        ))}
      </div>
      <div className="border-t border-brand-cream/15">
        <div className="container-site flex flex-col gap-3 py-6 text-sm text-brand-cream/70 lg:flex-row lg:items-center lg:justify-between">
          <p>© 2026 Felix Genuss · Feinschmecker seit 2025</p>
          <p>
            Diese Website wurde erstellt von{' '}
            <a
              href="https://inderwildi.org/"
              target="_blank"
              rel="noopener"
              className="rounded-sm font-semibold text-brand-cream underline decoration-brand-gold/60 underline-offset-4 transition-colors duration-200 hover:text-white"
              data-testid="footer-creator-link"
            >
              inderwildi.org
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
